import { BusinessDisplayUnit } from '../../../types/business-group-type';
import styled from 'styled-components';
import React from 'react';
import SearchBusinessWithBusinessGroupDisplayUnitItem from './SearchBusinessWithBusinessGroupDisplayUnitItem';

interface SearchBusinessWithBUsinessGroupListProps {
    businessDisplayUnitList: BusinessDisplayUnit[];
    onSelect: (businessDisplayUnit: BusinessDisplayUnit) => void;
}

const StyledSearchBusinessWithBusinessGroupList = styled.div``;

const SearchBusinessWithBusinessGroupList = ({
                                                     businessDisplayUnitList,
                                                     onSelect,
                                                 }: SearchBusinessWithBUsinessGroupListProps) => {
    return (
        <StyledSearchBusinessWithBusinessGroupList>
            {businessDisplayUnitList.map((businessDisplayUnit) => {
                return (
                    // eslint-disable-next-line react/jsx-key
                    <div>
                        <SearchBusinessWithBusinessGroupDisplayUnitItem
                            businessDisplayUnit={businessDisplayUnit}
                            onSelect={onSelect}
                        />
                    </div>
                );
            })}
        </StyledSearchBusinessWithBusinessGroupList>
    );
};
export default SearchBusinessWithBusinessGroupList;